import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#0597A3"
      d="M101.26 22.72a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#00D8D8"
      d="m77.94 7.95 3.94-3.94c.59-.59.59-1.54 0-2.12a1.49 1.49 0 0 0-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0 1.49 1.49 0 0 0 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12z"
    />
    <path
      fill="#0597A3"
      d="M103.76 84.95a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      d="M21.83 24.82h-5.57v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57H7.69c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M11.7 83.95c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M58 97c21.54 0 39-17.46 39-39S79.54 19 58 19 19 36.46 19 58s17.46 39 39 39"
    />
    <path
      fill="#001A43"
      d="M58 71.23c-7.29 0-13.23-5.93-13.23-13.23S50.7 44.77 58 44.77 71.23 50.7 71.23 58 65.3 71.23 58 71.23m0-22c-4.84 0-8.77 3.93-8.77 8.77s3.93 8.77 8.77 8.77 8.77-3.93 8.77-8.77-3.93-8.77-8.77-8.77"
    />
    <path
      fill="#001A43"
      d="M100 55.74H87.09c-1.1-14.29-12.54-25.73-26.83-26.83V16c0-1.25-1.01-2.26-2.26-2.26s-2.26 1.01-2.26 2.26v12.91c-14.29 1.1-25.73 12.54-26.83 26.83H16c-1.25 0-2.26 1.01-2.26 2.26s1.01 2.26 2.26 2.26h12.91c1.1 14.29 12.54 25.73 26.83 26.83V100c0 1.25 1.01 2.26 2.26 2.26s2.26-1.01 2.26-2.26V87.09c14.29-1.1 25.73-12.54 26.83-26.83H100c1.25 0 2.26-1.01 2.26-2.26s-1.01-2.26-2.26-2.26M58 82.81c-13.68 0-24.81-11.13-24.81-24.81S44.32 33.19 58 33.19 82.81 44.32 82.81 58 71.68 82.81 58 82.81"
    />
  </svg>
);
const SvgEnrichedIconTargetInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconTargetInverted);
export default Memo;
